var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.keywords),function(keyword){return _c('li',{key:keyword,staticClass:"js-suggest-keyword c-suggest--keyword",on:{"mousedown":function($event){return _vm.select(keyword)}}},[_vm._v("\n    "+_vm._s(keyword)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }